import { kebabCase } from 'es-toolkit/compat';
import { type FC, useMemo } from 'react';
import { classes, stylesheet } from 'typestyle';
import { Avatar } from '../topbar/Avatar';
import { AllGroups, type CampaignGroup } from './filters.util';

export type GroupCardProps = {
  onClick: () => void;
  groupType: AllGroups | CampaignGroup;
  name: string;
  numItems: number;
  cardType: string;
  isNilGroup: boolean;
};

const css = stylesheet({
  groupCard: {
    $nest: {
      '.card-icon': {
        $nest: {
          '&.badge': {
            border: '1px solid rgba(0, 0, 0, .25)',
            borderRadius: '100%',
            display: 'block',
            height: 30,
            width: 30,
          },
        },
        color: '#757575',
        fontSize: '30px',
      },
      '.group-subtitle': {
        color: '#757575',
      },
      '.group-title': {
        fontFamily: 'AmazonEmber-Bold',
        fontSize: '14px',
      },
    },
    alignItems: 'center',
    display: 'flex',
    padding: '15px 15px 15px 20px',
    textAlign: 'left',
  },
});

export const GroupCard: FC<GroupCardProps> = ({ onClick, groupType, name, numItems, cardType, isNilGroup }) => {
  const groupIconClass = useMemo(() => {
    if (isNilGroup) {
      return '';
    }

    switch (groupType) {
      case AllGroups.ProductLine:
        return 'fa fa-files-o';
      case AllGroups.Platform:
        if (name.toLowerCase().includes('desktop')) {
          return 'fa fa-desktop';
        }
        if (name.toLowerCase().includes('tablet')) {
          return 'fa fa-tablet';
        }
        if (name.toLowerCase().includes('mobile')) {
          return 'fa fa-mobile-phone';
        }
        return '';
      case AllGroups.Tag:
        return 'fa fa-tag';
      case AllGroups.Status:
        return `badge badge-${kebabCase(name)}`;
      case AllGroups.Date:
        return 'fa fa-calendar';
    }
  }, [
    groupType,
    isNilGroup,
    name,
  ]);

  return (
    <button className={classes('summary-card', css.groupCard)} onClick={onClick} type="button">
      {groupType === AllGroups.Owner ? <Avatar username={name} /> : <i className={classes('card-icon', groupIconClass)} />}

      <div className="pl-3">
        <h4 className="group-title">{name}</h4>
        <span className="group-subtitle">
          {numItems} {cardType}
        </span>
      </div>
    </button>
  );
};
